import BaseAPI from "../api";

const path: string = "activity-category";

export class ActivityCategoryApi extends BaseAPI {
  static createActivityCategory(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getActivityCategoryDropdown(query?: any): Promise<any> {
    return this.api.get(`${path}/dropdown`, {
      params: { ...query },
    });
  }

  static updateActivityCategory(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteActivityCategory(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static getActivityCategoryList(query?: any): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }
}